import request from '@/utils/request'

export function updateVersionCfg(data) {
  return request({
    url: 'api/v1/version/updateCfg',
    method: 'post',
    data: data
  })
}

export function getVersionCfg(data) {
  return request({
    url: 'api/v1/version/getCfg',
    method: 'get',
    params: data
  })
}
